import {
  ACTION_TYPE,
  FETCH_ACTIVE_TAB,
  FETCH_ASSIGN_VENDOR_DATA,
  FETCH_TRANSACTION_TYPE,
  FETCH_VENDOR_DATA,
  FETCH_WEBSITE_DATA,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  addEditAction: true,
  vendorData: null,
  assignVendorData: null,
  activeTab: "1",
  websiteList: null,
  transactionType: null,
  actionType: null,
};

const websiteReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_WEBSITE_DATA: {
      return {
        ...state,
        websiteList: action.payload,
      };
    }
    case FETCH_VENDOR_DATA: {
      return {
        ...state,
        vendorData: action.payload,
      };
    }
    case FETCH_ASSIGN_VENDOR_DATA: {
      return {
        ...state,
        assignVendorData: action.payload,
      };
    }
    case FETCH_ACTIVE_TAB: {
      return {
        ...state,
        activeTab: action.payload,
      };
    }
    case FETCH_TRANSACTION_TYPE: {
      return {
        ...state,
        transactionType: action.payload,
      };
    }
    case ACTION_TYPE: {
      return {
        ...state,
        actionType: action.payload,
      };
    }
    default:
      return state;
  }
};

export default websiteReducer;
